import { MapAddress } from "interfaces/interfaces";

type ProjectMapAddressFields = {
  addressLine1?: string | null;
  addressLine2?: string | null;
  addressCity?: string | null;
  addressState?: string | null;
  addressZip?: string | null;
  addressCountry?: string | null;
  latitude?: number | null;
  longitude?: number | null;
};

export const projectMapToMapAddress = (
  projectMap: ProjectMapAddressFields | null | undefined
): MapAddress | null => {
  if (!projectMap?.addressLine1) {
    return null;
  }

  return {
    line1: projectMap.addressLine1,
    line2: projectMap.addressLine2 ?? undefined,
    city: projectMap.addressCity ?? "",
    state: projectMap.addressState ?? "",
    zip: projectMap.addressZip ?? "",
    country: projectMap.addressCountry ?? "",
    lat: projectMap.latitude ?? 0,
    lng: projectMap.longitude ?? 0,
  };
};

export const mapAddressToUpdateProjectMapInput = (projectMapId: string, address: MapAddress) => ({
  id: projectMapId,
  addressLine1: address.line1,
  addressLine2: address.line2 ?? null,
  addressCity: address.city,
  addressState: address.state,
  addressZip: address.zip,
  addressCountry: address.country,
  latitude: address.lat,
  longitude: address.lng,
});

export const getAddressLine2FromPlace = (place: {
  address_components?: Array<{ long_name: string; types: string[] }>;
}) =>
  place.address_components?.find((component) => component.types.includes("subpremise"))
    ?.long_name ?? undefined;
